import React, { PureComponent } from 'react';
import styled from 'styled-components';
import colors from '@theme/colors';
import font from '@theme/font';

export default class DownloadButton extends PureComponent {
  render() {
    const Button = styled.span`
      color: ${colors.TEAL};
      cursor: pointer;
      font-size: ${font.screen.size.MEDIUM};
      border: 1px solid ${colors.TEAL};
      border-radius: 2px;
      padding: 3px 20px;
      transition: 300ms;

      &:hover {
        border: 1px solid ${colors.TEAL_INTENSIVE};
        color: ${colors.TEAL_INTENSIVE};
      }
    `;
    return <Button {...this.props}>{this.props.children}</Button>;
  }
}



// WEBPACK FOOTER //
// ./components/atoms/DownloadButton.js